// Segmentazione della landing: chi sei → esempio della demo già pronto per il tuo lavoro.
import { useEffect, useState } from "react";

export const TIPI = ["artigiano", "freelance", "avvocato", "pmi"];
const EVENTO = "op-tipo";

export const leggiTipo = () => {
  if (typeof window === "undefined") return "";
  const dallUrl = new URLSearchParams(window.location.search).get("tipo");
  if (dallUrl && TIPI.includes(dallUrl)) {
    localStorage.setItem("user_tipo", dallUrl);
    return dallUrl;
  }
  const salvato = localStorage.getItem("user_tipo");
  return TIPI.includes(salvato) ? salvato : "";
};

export const salvaTipo = (tipo) => {
  localStorage.setItem("user_tipo", tipo);
  const url = new URL(window.location.href);
  url.searchParams.set("tipo", tipo);
  window.history.replaceState({}, "", url);
  window.dispatchEvent(new CustomEvent(EVENTO, { detail: tipo }));
};

export const useTipo = () => {
  const [tipo, setTipo] = useState(leggiTipo);
  useEffect(() => {
    const ascolta = (e) => setTipo(e.detail);
    window.addEventListener(EVENTO, ascolta);
    return () => window.removeEventListener(EVENTO, ascolta);
  }, []);
  return tipo;
};
